var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "presale-plan-modal",
      attrs: { title: "供货计划详情", "mask-closable": false, width: "800" },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "ivu-modal-close",
          attrs: { slot: "close" },
          on: { click: _vm.handleClose },
          slot: "close",
        },
        [_c("Icon", { attrs: { type: "ios-close" } })],
        1
      ),
      _c(
        "div",
        { staticClass: "modal-content" },
        [
          _vm.loading
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _vm.detailData
            ? _c("div", [
                _c("div", { staticClass: "highlight-panel" }, [
                  _c("div", { staticClass: "highlight-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("当前供货数量"),
                    ]),
                    _c("span", { staticClass: "value primary" }, [
                      _vm._v(
                        _vm._s(_vm.detailData.preSalePlanOfferAmount || 0)
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "divider" }),
                  _c("div", { staticClass: "highlight-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("当前供货价格"),
                    ]),
                    _c("span", { staticClass: "value price" }, [
                      _c("small", [_vm._v("¥")]),
                      _vm._v(
                        _vm._s(
                          _vm.formatPrice(_vm.detailData.preSalePlanPrice)
                        ) + "\n                    "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "divider" }),
                  _c("div", { staticClass: "highlight-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("更新时间")]),
                    _c("span", { staticClass: "value time" }, [
                      _vm._v(
                        _vm._s(_vm.formatDateTime(_vm.detailData.CreateTime))
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "info-card-container" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("基础与产品信息"),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-grid" }, [
                    _c("div", { staticClass: "grid-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("年份/周次"),
                      ]),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(
                          _vm._s(_vm.detailData.preSaleYear || "--") +
                            " 年 / " +
                            _vm._s(_vm.detailData.preSaleWeek || "--") +
                            " 周"
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "grid-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("绑定周期"),
                      ]),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(
                          _vm._s(_vm.detailData.seedFarmWeekBindingName || "--")
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "grid-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("产品名称"),
                      ]),
                      _c("span", { staticClass: "text bold" }, [
                        _vm._v(_vm._s(_vm.detailData.productName || "--")),
                      ]),
                    ]),
                    _c("div", { staticClass: "grid-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("产品编号"),
                      ]),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.detailData.productCode || "--")),
                      ]),
                    ]),
                    _c("div", { staticClass: "grid-item" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("规格")]),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.detailData.productSpec || "--")),
                      ]),
                    ]),
                    _c("div", { staticClass: "grid-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("苗场信息"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "text",
                          attrs: { title: _vm.detailData.seedFarmName },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.detailData.seedFarmName || "--") +
                              " \n                            "
                          ),
                          _vm.detailData.seedFarmCode
                            ? _c("span", { staticClass: "sub-text" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.detailData.seedFarmCode) +
                                    ")"
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm.detailData.oldValue ||
                _vm.detailData.newValue ||
                _vm.oldValue ||
                _vm.newValue
                  ? _c("div", { staticClass: "change-log-section" }, [
                      _c("div", { staticClass: "section-header" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("变更记录"),
                        ]),
                      ]),
                      _c("div", { staticClass: "diff-container" }, [
                        _c("div", { staticClass: "diff-box old" }, [
                          _c(
                            "div",
                            { staticClass: "diff-label" },
                            [
                              _c("Icon", {
                                attrs: { type: "md-remove-circle" },
                              }),
                              _vm._v(" 修改前"),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "diff-content" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.formatChangeValue(
                                    _vm.detailData.oldValue || _vm.oldValue
                                  ) || "无数据"
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "diff-arrow" },
                          [
                            _c("Icon", {
                              attrs: { type: "md-arrow-round-forward" },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "diff-box new" }, [
                          _c(
                            "div",
                            { staticClass: "diff-label" },
                            [
                              _c("Icon", { attrs: { type: "md-add-circle" } }),
                              _vm._v(" 修改后"),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "diff-content" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.formatChangeValue(
                                    _vm.detailData.newValue || _vm.newValue
                                  ) || "无数据"
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          !_vm.loading &&
          (!_vm.detailData ||
            (!_vm.detailData.productCode &&
              !_vm.detailData.preSaleYear &&
              !_vm.oldValue &&
              !_vm.newValue))
            ? _c("div", { staticClass: "empty-state" }, [
                _c(
                  "div",
                  { staticClass: "empty-icon" },
                  [_c("Icon", { attrs: { type: "ios-filing-outline" } })],
                  1
                ),
                _c("p", [_vm._v("暂无详细计划数据")]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }